module.exports = __webpack_public_path__ + "static/media/banner04.83089579.jpg";